import { InjectionToken } from '@angular/core';

export interface ThemePersistence {
  save(themeId: string): void;
  load(): string | null;
}

export const THEME_PERSISTENCE = new InjectionToken<ThemePersistence>(
  'THEME_PERSISTENCE'
);